export const MenuListIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3333 2.33325C15.7015 2.33325 16 2.63173 16 2.99992C16 3.36811 15.7015 3.66659 15.3333 3.66659H0.666667C0.298477 3.66659 0 3.36811 0 2.99992C0 2.63173 0.298477 2.33325 0.666667 2.33325H15.3333Z"
        fill="white"
      />
      <path
        d="M15.3333 6.99992C15.7015 6.99992 16 7.2984 16 7.66659C16 8.03478 15.7015 8.33325 15.3333 8.33325H0.666667C0.298477 8.33325 0 8.03478 0 7.66659C0 7.2984 0.298477 6.99992 0.666667 6.99992H15.3333Z"
        fill="white"
      />
      <path
        d="M15.3333 11.6666C15.7015 11.6666 16 11.9651 16 12.3333C16 12.7014 15.7015 12.9999 15.3333 12.9999H0.666667C0.298477 12.9999 0 12.7014 0 12.3333C0 11.9651 0.298477 11.6666 0.666667 11.6666H15.3333Z"
        fill="white"
      />
    </svg>
  );
};
